// https://skyhall-demos.s3.ap-northeast-2.amazonaws.com/img/avatars/avatar_11.jpg

const DemoState = {
  nftRepresentatives: [
    {
      image: 'https://skyhall-demos.s3.ap-northeast-2.amazonaws.com/img/products/item_12_lg.jpg',
      avatar: 'https://skyhall-demos.s3.ap-northeast-2.amazonaws.com/img/avatars/avatar_17_rounded.gif',
      title: 'Light Bars',
      name: 'Wow Frens'
    },
    {
      image: 'https://skyhall-demos.s3.ap-northeast-2.amazonaws.com/img/products/item_13_lg.gif',
      avatar: 'https://skyhall-demos.s3.ap-northeast-2.amazonaws.com/img/avatars/avatar_18_rounded.gif',
      title: 'A1Aerium NFT Launching Lab',
      name: '051_Hart',
    },
    {
      image: 'https://skyhall-demos.s3.ap-northeast-2.amazonaws.com/img/products/item_16_lg.jpg',
      avatar: 'https://skyhall-demos.s3.ap-northeast-2.amazonaws.com/img/avatars/avatar_2_rounded.gif',
      title: 'Oceania \\ OVERSEER',
      name: 'MadeByM1KE',
    },
    {
      image: 'https://skyhall-demos.s3.ap-northeast-2.amazonaws.com/img/products/item_14_lg.jpg',
      avatar: 'https://skyhall-demos.s3.ap-northeast-2.amazonaws.com/img/avatars/avatar_19_rounded.gif',
      title: 'Amazing NFT art',
      name: 'Lila Spacex'
    },
    {
      image: 'https://skyhall-demos.s3.ap-northeast-2.amazonaws.com/img/products/item_15_lg.jpg',
      avatar: 'https://skyhall-demos.s3.ap-northeast-2.amazonaws.com/img/avatars/avatar_20_rounded.gif',
      title: 'SwagFox#133',
      name: 'Bored Bunny'
    },
  ],
}

export default DemoState;
